// Сортування списку контрагентів за колонками (як у «Русі товарів»): назва, придбано, продано, кількість ПН/РК,
// остання ПН, стан реєстрів ДПС. Рядки без значення (немає ПН, не перевіряли) — завжди в кінці, незалежно від напряму.
export const PARTNER_SORT_KEYS = ["name", "in", "out", "docs", "last", "check"];
export const PARTNER_TEXT_SORT = new Set(["name"]);
export const PARTNER_DEFAULT_SORT = { key: "out_in", dir: "desc" };
const CHECK_RANK = { bad: 3, warn: 2, ok: 1 }; // «ризик» → «перевірено не все» → «без зауважень»

const val = (p, key) => {
  switch (key) {
    case "name": return String(p.name || "").trim().toLocaleLowerCase("uk") || null;
    case "in": return p.in_count ? Number(p.in_total) : null;
    case "out": return p.out_count ? Number(p.out_total) : null;
    case "docs": return (p.in_count || 0) + (p.out_count || 0) || null;
    case "last": return p.last_date ? String(p.last_date).slice(0, 10) : null;
    case "check": return p.check ? CHECK_RANK[p.check.tone] || 0 : null;
    default: return Number(p.in_total) + Number(p.out_total); // типово — за оборотом
  }
};

export function sortPartners(list, sort = PARTNER_DEFAULT_SORT) {
  const key = PARTNER_SORT_KEYS.includes(sort?.key) ? sort.key : "out_in";
  const dir = sort?.dir === "asc" ? 1 : -1;
  return [...list].sort((a, b) => {
    const x = val(a, key), y = val(b, key);
    if (x == null && y == null) return String(a.tin).localeCompare(String(b.tin));
    if (x == null) return 1;
    if (y == null) return -1;
    const c = typeof x === "string" ? x.localeCompare(y, "uk") : x - y;
    return c * dir || String(a.tin).localeCompare(String(b.tin));
  });
}
